import {Service} from "@/services/superclasses/service";
import {Certificate} from "@/interfaces/certificate";

const api = window.contextPath + '/rest/certificates';

export class CertificateService extends Service {

    constructor() {
        super()
    }

    public lookup = async (id: Array<number>): Promise<Certificate> => {
        return this.data(await this.get<Certificate>(api + "/autocomplete",
            {
                params: {
                    id
                }
            }))
    }
}

export const certificateService = new CertificateService()
